import { render, staticRenderFns } from "./EstimateStatusBadge.vue?vue&type=template&id=5720b131"
import script from "./EstimateStatusBadge.vue?vue&type=script&lang=js"
export * from "./EstimateStatusBadge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports